import { ADD_TO_WATCHLIST, WATCHLIST_HAS_NOTIFICATION } from '../../constants';

const className = 'icon--has-bullet';
const watchlistPath = '/area-privata/preferiti';

export default class WatchlistButtonHeader {
    constructor(element) {
        this.$element = $(element);
        this.currentPath = location.pathname;
        this.onWatchlistChange = this.onWatchlistChange.bind(this);
    }

    init() {
        this.addEventListeners();
        this.onElementMount();
    }

    addEventListeners() {
        document.addEventListener(ADD_TO_WATCHLIST, this.onWatchlistChange);
    }

    toggleNotification() {
        const $svgWrapper = this.$element.find('span');
        const hasClass = $svgWrapper.hasClass(className);

        if(hasClass && !this.watchlistFlag) {
            $svgWrapper.removeClass(className);
        }

        if(!hasClass && this.watchlistFlag) {
            $svgWrapper.addClass(className);
        }
    }

    onElementMount() {
        // useful to avoid notifications 
        // if the user is logged-out
        if(this.$element.data('ignore-notification')) {
            return false;
        }

        if(this.currentPath === watchlistPath) {
            this.setWatchlistFlag(false); // disable notification once it is shown
        }

        this.toggleNotification();
    }

    setWatchlistFlag(flag) {
        try {
            localStorage.setItem(WATCHLIST_HAS_NOTIFICATION, flag);
        } catch (error) {
            console.error('ERROR: ' + JSON.stringify(error));
        }
    }

    get watchlistFlag() {
        return JSON.parse(localStorage.getItem(WATCHLIST_HAS_NOTIFICATION));
    }

    onWatchlistChange() {
        // skip notification if already in watchlist page
        if(this.currentPath === watchlistPath) {
            return false;
        }
        //

        this.setWatchlistFlag(true);
        this.toggleNotification();
    }
}
